<script lang="ts">
  import { SearchState } from "../../services/search-service";
  import type { SearchStateModel } from "../../models/search.interface";
  import { deleteSearchQueryStringParameter, setQueryStringParameter } from "../../url";
  import TooltipHybridButton from "./TooltipHybridButton.svelte";

  export let observationTypeData;

  let observationTypeSearchInput = [];

  function onChange(id) {
    observationTypeSearchInput.includes(id)
      ? setQueryStringParameter("observationTypes", id, true)
      : deleteSearchQueryStringParameter("observationTypes", id);
  }

  SearchState.subscribe((search: SearchStateModel) => {
    observationTypeSearchInput = search.params.getAll("observationTypes")
      ? search.params.getAll("observationTypes")
      : [];
  });
</script>

<li class="mb-1">
  <form>
    <fieldset>
      <legend class="mb-2 fs-5">
        Observation Type
        <!-- tooltip icon -->
        <TooltipHybridButton
          searchUrlQueryParam="observation-type"
          tooltip="This is a list of all observation types available in data access. Some datasets are
            composed of station observations, while others are satellite observations. These are
            referred to as the datasets <b>observation types</b>."
        />
        <!--        <button-->
        <!--          type="button"-->
        <!--          id="observationTypeToolTip"-->
        <!--          class="btn btn-link mb-1 ps-1"-->
        <!--          style="color: #1E2125;"-->
        <!--          aria-describedby="observationTypeToolTipContent"-->
        <!--        >-->
        <!--          <i class="bi bi-question-circle-fill" aria-hidden="true"></i>-->
        <!--        </button>-->
        <!--        <Tooltip-->
        <!--          id="observationTypeToolTipContent"-->
        <!--          target={`observationTypeToolTip`}-->
        <!--          placement="right"-->
        <!--          role="tooltip"-->
        <!--        >-->
        <!--          <p>-->
        <!--            This is a list of all observation types available in data access. Some datasets are-->
        <!--            composed of station observations, while others are satellite observations. These are-->
        <!--            referred to as the datasets <b>observation types</b>.-->
        <!--          </p>-->
        <!--        </Tooltip>-->
      </legend>

      <!-- observation type list -->
      {#each observationTypeData as o, i}
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            role="checkbox"
            id="ot-{o.id}-checkbox"
            aria-checked={observationTypeSearchInput.includes(o.id)}
            value={o.name}
            bind:group={observationTypeSearchInput}
            on:change={() => onChange(o.id)}
          />
          <label class="form-check-label" for="ot-{o.id}-checkbox">
            {o.name}
          </label>
        </div>
      {/each}
    </fieldset>
  </form>


  {#if $SearchState.params.has("observationTypes")}
    {#each observationTypeSearchInput || [] as o, i}
      <div class="d-flex py-1">
        <span
          style="overflow-x: hidden; text-overflow: ellipsis"
          class="badge rounded-pill text-bg-dark pb-0 pe-3 pt-1"
          role="status"
          aria-label="observation type search pill: {o}"
        >
          <button
            type="button"
            class="btn p-0 m-0"
            on:click={() => deleteSearchQueryStringParameter("observationTypes", o)}
          >
            <i class="bi bi-x text-bg-dark" aria-label="Delete observation type {o}"></i>
          </button>
          {o}
        </span>
      </div>
    {/each}
  {/if}
</li>
